import React from "react";

import ShellCard from "components/ShellCard";
import MetricCardGroup from "components/MetricCardGroup";
import MetricCard from "components/MetricCard";

import { fmtInt } from "../../ConferenciaFatura/formatters";
import { fmtMinutos } from "./formatos";
import renderEstadoSecao from "./EstadoSecao";

const EYEBROW = "Janela da auditoria";
const TITULO = "Da entrada no Hub até a fatura ser Liberada";
const DESCRICAO =
  "Mede só o trecho que é nosso: quanto tempo a fatura passa dentro da auditoria, da entrada no Hub até a liberação. Não inclui o tempo da transportadora para emitir nem o do ERP para integrar.";

/**
 * Seção da H2 (PO1-3000): a janela da auditoria da MESMA coorte da H1, medida
 * no backend sobre o histórico de conciliação (FaturaConciliacao).
 *
 * Faturas com histórico retrodatado pelo AutoPilot ("sintéticas") ficam fora
 * das durações e são contadas no card próprio — o critério de aceite é que
 * nada suma em silêncio.
 */
export default function JanelaAuditoria({ estado }) {
  const bloqueio = renderEstadoSecao(estado, "Sem faturas na coorte do período.");

  if (bloqueio) {
    return (
      <ShellCard eyebrow={EYEBROW} title={TITULO} description={DESCRICAO}>
        {bloqueio}
      </ShellCard>
    );
  }

  const { coorte, janelaAuditoria } = estado.data;
  const foraDaMedicao = coorte.faturas - janelaAuditoria.faturas;

  return (
    <>
      <MetricCardGroup eyebrow={EYEBROW} title={TITULO} description={DESCRICAO}>
        <MetricCard
          label="Média"
          tone="info"
          iconClassName="tim-icons icon-time-alarm"
          value={fmtMinutos(janelaAuditoria.mediaMin)}
          helper={`${fmtInt(janelaAuditoria.faturas)} fatura(s) medida(s)`}
        />
        <MetricCard
          label="Mediana"
          tone="success"
          iconClassName="tim-icons icon-chart-bar-32"
          value={fmtMinutos(janelaAuditoria.medianaMin)}
          helper="Metade das faturas é liberada em até esse prazo"
        />
        <MetricCard
          label="P90"
          tone="warning"
          iconClassName="tim-icons icon-alert-circle-exc"
          value={fmtMinutos(janelaAuditoria.p90Min)}
          helper="9 em cada 10 faturas são liberadas em até esse prazo"
        />
        <MetricCard
          label="Máximo"
          tone="pink"
          iconClassName="tim-icons icon-sound-wave"
          value={fmtMinutos(janelaAuditoria.maxMin)}
          helper="Pior caso do período"
        />
        <MetricCard
          label="Faturas na coorte"
          tone="neutral"
          iconClassName="tim-icons icon-single-copy-04"
          value={fmtInt(coorte.faturas)}
          helper={`${fmtInt(coorte.comHistorico)} com histórico de conciliação`}
        />
        <MetricCard
          label="Fora da medição"
          tone={foraDaMedicao > 0 ? "warning" : "success"}
          iconClassName="tim-icons icon-alert-circle-exc"
          value={fmtInt(foraDaMedicao)}
          helper={`${fmtInt(coorte.sinteticas)} sintética(s) · ${fmtInt(
            coorte.semLiberacao
          )} sem marco de liberação`}
        />
      </MetricCardGroup>
      {coorte.sinteticas > 0 ? (
        <p className="lt-footnote lt-footnote--solta">
          {fmtInt(coorte.sinteticas)} fatura(s) tiveram o histórico retrodatado
          pelo AutoPilot (regularização de fatura vencida). Elas contam na coorte
          mas ficam fora das durações — o carimbo de tempo delas não é o momento
          em que a etapa aconteceu.
        </p>
      ) : null}
    </>
  );
}
